import { Currency } from './currency.model';

export class Fee {
  totalPrice: number;
  irrPrice: number;
  date!: string;

  constructor(input: any = {}) {
    this.totalPrice = input.total_fee;
    this.irrPrice = Number(input.irr_price);
    this.date = input.date;
  }
}

export class FeeChartModel {
  currency!: Currency;
  fees!: Fee[];

  constructor() {}
}
